import React from 'react';
var ArrowLeftIcon = function () {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "6", height: "12", viewBox: "0 0 6 12" },
        React.createElement("path", { fill: 'currentColor', transform: "rotate(-90 6 6)", "data-name": "Path 28691", d: "M5.29.253a1.121 1.121 0 0 1 1.419 0l5 4.28a.775.775 0 0 1 0 1.215 1.126 1.126 0 0 1-1.419 0L6 2.068l-4.287 3.68a1.126 1.126 0 0 1-1.419 0 .775.775 0 0 1 0-1.215z" })));
};
export default ArrowLeftIcon;
//# sourceMappingURL=arrow-left-icon.js.map